
import styles from "./ediror.module.scss";
import { useEffect, useState } from "react";
import { getFlags, createCard } from "../../../pages/api/sportcards";
import { useStore } from "../../../stores/use_global_state";

const Text = ({ sportCardsState, setSportCardsState, setSteps }) => {
  const { state } = useStore();
  let token = state?.userInfo?.token ? state.userInfo.token : false;
  const [flags, setFlags] = useState([]);
  const [activeItem, setactiveItem] = useState("first_name");


  useEffect(() => {
    const getFlagsList = async () => {
      const response = await getFlags();
      setFlags(response.data);
    }

    getFlagsList()
  }, [])

  const Next = async () => {
    const data = {
      person_id: sportCardsState.person.id,
      pose_id: sportCardsState.pose.id,
      template_id: sportCardsState.template.id,
      background_id: sportCardsState.background.id,
      first_name: sportCardsState.name,
      last_name: sportCardsState.surname,
      position: sportCardsState.position,
      flag_id: sportCardsState.flag_id,
      logo1_id: sportCardsState.logo["1"] ? sportCardsState.logo["1"].id : null,
      logo2_id: sportCardsState.logo["2"] ? sportCardsState.logo["2"].id : null,
      num1: sportCardsState.num1,
      desc1: sportCardsState.desc1,
      num2: sportCardsState.num2,
      desc2: sportCardsState.desc2
    }

    await createCard(data, token);

    setSteps(prev => prev.map(step => step.name === "Download" ? { ...step, active: true } : { ...step, active: false }));
  }

  const nextBtnDisabled = sportCardsState.name.length < 1 || sportCardsState.surname.length < 1 || sportCardsState.position.length < 1 || (sportCardsState.template?.has_num1 && sportCardsState.num1.length < 1) ||
    (sportCardsState.template?.has_num2 && sportCardsState.num2.length < 1) || sportCardsState.template?.has_flag && sportCardsState.flag === null;

  const goToItem = (target, itemName) => {
    target.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    document.getElementById(itemName + "Input").scrollIntoView({ behavior: 'smooth', });
    setactiveItem(itemName)
  }

  const onFocus = ({ target }) => {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1024) {
      target.scrollIntoView({ behavior: 'smooth', inline: 'center' });
      const menuName = target.getAttribute("data-name");
      const menuItem = document.getElementById(menuName);
      menuItem.scrollIntoView({ behavior: 'smooth', inline: 'center' });
      setactiveItem(menuName)
    }
  }

  return (
    <>
      <div className={styles.textMenu}>
        <button id="first_name" className={`${styles.textMenuBtn} ${activeItem === "first_name" ? styles.active : ""}`} onClick={({ target }) => goToItem(target, "first_name")}>First name</button>
        <button id="last_name" className={`${styles.textMenuBtn} ${activeItem === "last_name" ? styles.active : ""}`} onClick={({ target }) => goToItem(target, "last_name")}>Last name</button>
        <button id="position" className={`${styles.textMenuBtn} ${activeItem === "position" ? styles.active : ""}`} onClick={({ target }) => goToItem(target, "position")}>Position</button>
        {sportCardsState.template?.has_num1 && <button id="number_1" className={`${styles.textMenuBtn} ${activeItem === "number_1" ? styles.active : ""}`} onClick={({ target }) => goToItem(target, "number_1")}>Number 1</button>}
        {sportCardsState.template?.has_num2 && <button id="number_2" className={`${styles.textMenuBtn} ${activeItem === "number_2" ? styles.active : ""}`} onClick={({ target }) => goToItem(target, "number_2")}>Number 2</button>}
        {sportCardsState.template?.has_flag && <button id="flag" className={`${styles.textMenuBtn} ${activeItem === "flag" ? styles.active : ""}`} onClick={({ target }) => goToItem(target, "flag")}>Flag</button>}
      </div>
      <div className={styles.textWrapeer}>
        <div className={`${styles.textBox} ${styles.textBox70}`}>
          <h3 className={styles.textBoxTitle}>FIRST & LAST NAME</h3>
          <div className={styles.textWrapper} id="first_nameInput">
            <h3 className={styles.itemTitle}>First name</h3>
            <p className={styles.itemDescription}>10 symbols max</p>
            <input data-name="first_name" className={styles.input} maxlength="10" type="text" placeholder="Name" value={sportCardsState.name} onFocus={onFocus} onChange={(e) => setSportCardsState({ ...sportCardsState, name: e.target.value })} />
          </div>

          <div className={styles.textWrapper} id="last_nameInput">
            <h3 className={styles.itemTitle}>Last name</h3>
            <p className={styles.itemDescription}>10 symbols max</p>
            <input data-name="last_name" className={styles.input} maxlength="10" type="text" placeholder="Surname" value={sportCardsState.surname} onFocus={onFocus} onChange={(e) => setSportCardsState({ ...sportCardsState, surname: e.target.value })} />
          </div>
        </div>

        <div className={`${styles.textBox} ${styles.textBox30}`}>
          <h3 className={styles.textBoxTitle}>POSITION</h3>
          <div className={styles.textWrapper} id="positionInput">
            <h3 className={styles.itemTitle}>Position or role</h3>
            <p className={styles.itemDescription}>11 symbols max</p>
            <input data-name="position" className={styles.input} maxlength="11" type="text" placeholder="Position or role" value={sportCardsState.position} onFocus={onFocus} onChange={(e) => setSportCardsState({ ...sportCardsState, position: e.target.value })} />
          </div>
        </div>

        {
          sportCardsState.template?.has_num1 && <div className={`${styles.textBox} ${styles.textBox50}`} id="number_1Input">
            <h3 className={styles.textBoxTitle}>Number 1</h3>
            <div className={styles.textWrapper}>
              <h3 className={styles.itemTitle}>Value</h3>
              <p className={styles.itemDescription}>2 symbols</p>
              <input data-name="number_1" className={styles.input} maxlength="2" type="text" placeholder="Value" value={sportCardsState.num1} onFocus={onFocus} onChange={(e) => setSportCardsState({ ...sportCardsState, num1: e.target.value })} />
            </div>

            <div className={styles.textWrapper}>
              <h3 className={styles.itemTitle}>Description</h3>
              <p className={styles.itemDescription}>7 symbols max</p>
              <input data-name="number_1" className={styles.input} maxlength="7" type="text" placeholder="Description" value={sportCardsState.desc1} onFocus={onFocus} onChange={(e) => setSportCardsState({ ...sportCardsState, desc1: e.target.value })} />
            </div>
          </div>}

        {sportCardsState.template?.has_num2 && <div className={`${styles.textBox} ${styles.textBox50}`} id="number_2Input">
          <h3 className={styles.textBoxTitle}>Number 2</h3>
          <div className={styles.textWrapper}>
            <h3 className={styles.itemTitle}>Value</h3>
            <p className={styles.itemDescription}>2 symbols</p>
            <input data-name="number_2" className={styles.input} maxlength="2" type="text" placeholder="Value" value={sportCardsState.num2} onFocus={onFocus} onChange={(e) => setSportCardsState({ ...sportCardsState, num2: e.target.value })} />
          </div>

          <div className={styles.textWrapper}>
            <h3 className={styles.itemTitle}>Description</h3>
            <p className={styles.itemDescription}>7 symbols max</p>
            <input data-name="number_2" className={styles.input} maxlength="7" type="text" placeholder="Description" value={sportCardsState.desc2} onFocus={onFocus} onChange={(e) => setSportCardsState({ ...sportCardsState, desc2: e.target.value })} />
          </div>
        </div>}

        {
          sportCardsState.template?.has_flag && <div className={`${styles.textBox} ${styles.textBox50}`}>
            <h3 className={styles.textBoxTitle}>FLAG</h3>
            <div className={styles.selectorWrapper} id="flagInput">
              <h4 className={styles.itemTitle}>Select country</h4>
              <select data-name="flag" className={styles.selector} name="flags" onFocus={onFocus} onChange={(e) => setSportCardsState({ ...sportCardsState, flag: flags.find((flag) => flag.id === e.target.value) })}>
                {flags.map((flag) => (
                  <option key={flag.id} value={flag.id}>{flag.name}</option>
                ))}
              </select>
            </div>
          </div>
        }
      </div >
      <button onClick={Next} disabled={nextBtnDisabled} className={styles.nextBtn}>Generate for 10 credits</button>
    </>

  )
}

export default Text